import _defineProperty from "/opt/jenkins_worker/workspace/zbcloud-master-\u4EBA\u5458\u5B9A\u4F4D/zbcloud-unify-auth-pro-hyc/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import { createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue";
import "core-js/modules/web.url-search-params.delete.js";
import "core-js/modules/web.url-search-params.has.js";
import "core-js/modules/web.url-search-params.size.js";
import "core-js/modules/es.array.push.js";
import Render from "@/render/Render";
import VueQrcode from '@chenfengyuan/vue-qrcode';
import { reactive, ref } from "vue";
// 组件依赖
import { ElForm } from "element-plus";
//import Verify from "@/components/Verifition/Verify";
// 状态管理依赖
import useUserStore from "@/stores/user";
// API依赖
import { getLastApk, getTenantList } from "@/api/admin";
import router from "@/router";
const BgImg = require('@/assets/login/bg.png');
const LoginTitle = require('@/assets/login/title.png');
const LoginFormBg = require('@/assets/login/form-bg.png');
const LoginFormButtonBg = require('@/assets/login/button-bg.png');
const formUserName = require('@/assets/login/form-username.png');
const formPassword = require('@/assets/login/form-password.png');
const formTenant = require('@/assets/login/form-tenant.png');
export class LoginView extends Render {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "userStore", useUserStore());
    _defineProperty(this, "verifyRef", ref());
    _defineProperty(this, "loading", ref(false));
    _defineProperty(this, "showVerifyBox", ref(false));
    _defineProperty(this, "appUrl", ref());
    // 样式
    _defineProperty(this, "styles", {
      loginMain: {
        width: "100%",
        height: "100vh",
        backgroundImage: `url(${BgImg})`,
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
        backgroundPosition: "center bottom"
      },
      loginBx: {
        width: "435px",
        backgroundImage: `url(${LoginFormBg})`,
        backgroundRepeat: "no-repeat",
        backgroundSize: "100% 100%"
      },
      fromBox: {
        width: "100%"
      },
      formButton: {
        width: "100%",
        backgroundImage: `url(${LoginFormButtonBg})`,
        backgroundRepeat: "no-repeat",
        backgroundSize: "100% 100%",
        backgroundColor: 'transparent',
        marginTop: '20px'
      }
    });
    _defineProperty(this, "loginFormRef", ref(ElForm));
    _defineProperty(this, "usernameRef", ref());
    // 登录表单
    _defineProperty(this, "loginData", ref({
      username: process.env.VUE_APP_DEFAULT_USERNAME,
      password: process.env.VUE_APP_DEFAULT_PASSWORD,
      code: '',
      randomStr: 'blockPuzzle',
      grant_type: 'password'
    }));
    _defineProperty(this, "loginRules", ref({
      username: [{
        required: true,
        trigger: "blur",
        message: "用户名不能为空"
      }],
      password: [{
        required: true,
        trigger: "blur",
        message: "密码不能为空"
      }]
    }));
    _defineProperty(this, "state", reactive({
      submitLoading: false,
      tenantList: [],
      tenant: {
        name: '',
        id: Number(process.env.VUE_APP_TENANT_ID) || undefined,
        code: process.env.VUE_APP_TENANT_CODE || '' // 租户ID
      },

      codeImg: ""
    }));
    // 登录表单
    _defineProperty(this, "logFrom", () => {
      return _createVNode(_resolveComponent("el-form"), {
        "ref": this.loginFormRef,
        "model": this.loginData.value,
        "rules": this.loginRules.value,
        "scroll-to-error": true,
        "status-icon": true,
        "class": "login-form",
        "onKeyup": event => {
          event.preventDefault();
          if (event.keyCode === 13) {
            this.onHandleLogin();
          }
        }
      }, {
        default: () => [_createVNode(_resolveComponent("el-form-item"), {
          "prop": "username"
        }, {
          default: () => [_createVNode(_resolveComponent("el-input"), {
            "ref": this.usernameRef,
            "modelValue": this.loginData.value.username,
            "onUpdate:modelValue": $event => this.loginData.value.username = $event,
            "placeholder": "\u8BF7\u8F93\u5165\u7528\u6237\u540D",
            "name": "username",
            "type": "text",
            "tabindex": "1",
            "size": "large",
            "auto-complete": "on"
          }, {
            prefix: () => _createVNode("img", {
              "src": formUserName,
              "alt": ""
            }, null)
          })]
        }), _createVNode(_resolveComponent("el-form-item"), {
          "prop": "password"
        }, {
          default: () => [_createVNode(_resolveComponent("el-input"), {
            "ref": "password",
            "modelValue": this.loginData.value.password,
            "onUpdate:modelValue": $event => this.loginData.value.password = $event,
            "placeholder": "\u8BF7\u8F93\u5165\u5BC6\u7801",
            "name": "password",
            "type": "password",
            "tabindex": "2",
            "size": "large",
            "auto-complete": "on",
            "show-password": true
          }, {
            prefix: () => _createVNode("img", {
              "src": formPassword,
              "alt": ""
            }, null)
          })]
        }), _createVNode("div", null, null), _createVNode(_resolveComponent("el-button"), {
          "style": this.styles.formButton,
          "size": "large",
          "loading": this.state.submitLoading,
          "type": "primary",
          "onClick": this.onHandleLogin.bind(this)
        }, {
          default: () => [_createTextVNode("\u767B\u5F55")]
        })]
      });
    });
    // 执行登录事件
    _defineProperty(this, "onHandleLogin", async () => {
      if (!this.loginFormRef) return;
      try {
        this.state.submitLoading = true;
        // 去掉验证码
        // this.showVerifyBox.value = true;
        // 校验表单
        await this.loginFormRef.value.validate();
        await this.userStore.loginByUsername(this.loginData.value, this.state.tenant);
        sessionStorage.setItem('redirectUrl', '');
        let redirectUrl = sessionStorage.getItem('redirectUrl');
        if (!redirectUrl) {
          // 判断是否有 referrer referrer是 low-code-pc 项目用的 退出时没有传递当前的url
          redirectUrl = sessionStorage.getItem('referrer');
        }
        if (redirectUrl) {
          const redirectUrlObj = new URL(decodeURIComponent(redirectUrl));
          const otherParams = getPublicParms({
            redirectUrl
          });
          redirectUrlObj.origin !== location.origin && Object.entries(otherParams)?.forEach(([key, value]) => {
            redirectUrlObj.searchParams.append(key, value);
          });
          sessionStorage.removeItem('redirectUrl');
          sessionStorage.removeItem('referrer');
          window.location.href = redirectUrlObj.toString();
        } else {
          router.push({
            path: '/'
          });
        }
        this.state.submitLoading = false;
        // console.log(this.verifyRef, '== verifyRef1111 ==');
      } catch (e) {
        console.log('121231221', e);
        this.state.submitLoading = false;
      }
    });
    // 关闭验证码弹窗
    _defineProperty(this, "onClose", () => {
      this.showVerifyBox.value = false;
    });
    //登录成功
    _defineProperty(this, "onSuccess", async data => {
      if (!data) return;
      this.showVerifyBox.value = false;
      this.loginData.value.code = data;
      await this.userStore.loginByUsername(this.loginData.value, this.state.tenant);
      router.push({
        path: '/'
      });
    });
    // 获取初始数据
    _defineProperty(this, "initData", async () => {
      if (!process.env.VUE_APP_TENANT_ID) {
        // 租户列表
        const tenantList = await getTenantList();
        this.state.tenantList = tenantList || [];
        this.state.tenant = this.state.tenantList[0];
      }
      this.initApk();
    });
  }
  async initApk() {
    console.log('initApk ');
    const apk = await getLastApk({
      tenantId: process.env.VUE_APP_TENANT_ID || this.state.tenant.id + '',
      serviceCode: 'UNIBOOT',
      fileType: 'apk'
    });
    if (apk?.url && !apk?.url?.startsWith('http')) {
      this.appUrl.value = (process.env.VUE_APP_NETWORK_OSS_BUCKET || window.location.origin) + (apk?.url || '');
    } else if (apk?.url) {
      this.appUrl.value = apk?.url;
    }
  }
  onClick() {}
  onMounted() {
    this.usernameRef.value.focus();
    this.initData();
    const uri = new URL(window.location.href);
    const username = uri.searchParams.get('username');
    const password = uri.searchParams.get('password');
    if (username && password) {
      this.loginData.value.username = username || '';
      this.loginData.value.password = password || '';
      this.onHandleLogin();
    }
    console.log(process.env);
  }
  render() {
    return _createVNode("div", {
      "class": "login-main fixed left-0 top-0 z-99 flex justify-center items-center",
      "style": this.styles.loginMain
    }, [_createVNode("div", {
      "class": "flex flex-col justify-center items-center"
    }, [_createVNode("img", {
      "class": "w-[534px] h-[130px]",
      "src": LoginTitle,
      "alt": ""
    }, null), _createVNode("div", {
      "class": "login-box flex justify-center px-30 py-[45px]",
      "style": {
        ...this.styles.loginBx,
        width: this.appUrl.value ? '460px' : '435px'
      }
    }, [_createVNode("div", {
      "class": "w-full"
    }, [_createVNode("div", {
      "class": "title-container"
    }, [_createVNode("h6", {
      "class": "small-title text-2xl text-white text-center mb-30"
    }, [_createTextVNode("\u6B22\u8FCE\u767B\u5F55")])]), _createVNode("div", {
      "class": "from-box",
      "style": this.styles.fromBox
    }, [!process.env.VUE_APP_TENANT_ID && this.state.tenantList.length > 1 ? _createVNode(_resolveComponent("el-select"), {
      "modelValue": this.state.tenant,
      "onUpdate:modelValue": $event => this.state.tenant = $event,
      "class": "m-2 mb-20",
      "placeholder": "\u8BF7\u9009\u62E9",
      "size": "large",
      "onChange": this.initApk.bind(this),
      "style": "width:100%;",
      "value-key": "id"
    }, {
      default: () => [this.state.tenantList.map(item => {
        return _createVNode(_resolveComponent("el-option"), {
          "label": item.name,
          "value": item
        }, null);
      })],
      prefix: () => _createVNode("img", {
        "src": formTenant,
        "alt": ""
      }, null)
    }) : '', this.logFrom()])]), this.appUrl.value && _createVNode("div", {
      "class": "ml-36 mt-36 flex flex-col items-center"
    }, [_createVNode(VueQrcode, {
      "style": {
        width: '120px',
        height: '120px'
      },
      "value": this.appUrl.value,
      "options": {
        type: '0',
        amount: '0',
        height: 120,
        width: 120
      }
    }, null), _createVNode("div", {
      "class": "text-white mt-12"
    }, [_createTextVNode("\u626B\u4E00\u626B\u4E0B\u8F7D\u624B\u673A\u5BA2\u6237\u7AEF")])])])])]);
  }
}
export default defineComponent({
  name: 'LoginView',
  props: LoginView.defineProps,
  emits: LoginView.defineEmits,
  created() {
    this.render.onCreated?.();
  },
  beforeMount() {
    this.render.OnBeforeMount?.();
  },
  mounted() {
    this.render.onMounted?.();
  },
  unmounted() {
    this.render.onUnmounted?.();
  },
  beforeUpdate() {
    this.render.onBeforeUpdate?.();
  },
  updated() {
    this.render.OnUpdated?.();
  },
  activated() {
    this.render.onActivated?.();
  },
  deactivated() {
    this.render.onDeactivated?.();
  },
  beforeUnmount() {
    this.render.onBeforeUnmount?.();
  },
  setup(props, context) {
    const render = new LoginView();
    render.props = props;
    render.context = context;
    render.emit = context.emit.bind(render.context);
    render?.onSetup?.();
    return {
      ...render,
      render: render
    };
  },
  render(setup) {
    // 挂载插槽
    this.render.slots = useSlots.call(setup);
    // 挂载属性
    this.render.attrs = useAttrs.call(setup);
    // 挂载路由参数
    this.render.route = useRoute.call(setup);
    return this.render.render();
  }
});